module.exports = __webpack_public_path__ + "static/Image18@2x-7186bf102c277c82c92633333b4c69e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/design/photos/Image18@2x.jpg
// module id = 911
// module chunks = 227233210825294 244429959259914